<mat-accordion>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-title-small">
        Application Form State
      </mat-panel-title>
    </mat-expansion-panel-header>
    @let _formVisualizerUrl = formVisualizerUrl();
    @if (_formVisualizerUrl) {
      <emperor-link-button [href]="_formVisualizerUrl" target="_blank">
        <span class="link-button-text">View in Partner Engine</span>
      </emperor-link-button>
    }
    <ul>
      <li>
        <span>appFormId: </span>
        <span>{{ appFormId() }}</span>
      </li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
